/**
 * Google Maps Shared Configuration
 * 
 * This module provides a centralized configuration for Google Maps API loading.
 * All components that use Google Maps (except SatelliteCommand which has its own config)
 * should use this shared configuration to avoid loader conflicts.
 * 
 * The @react-google-maps/api library throws an error if useJsApiLoader is called
 * multiple times with different options. By centralizing the config, we ensure
 * consistency across the application.
 */

// Libraries used by navigation and fleet components
// SatelliteCommand uses its own configuration - DO NOT change this for SatelliteCommand
export const GOOGLE_MAPS_LIBRARIES: ("places" | "geometry" | "drawing" | "visualization")[] = [
    "places",
    "geometry"
];

// Shared loader options for all map components
export const getGoogleMapsLoaderOptions = () => ({
    id: 'google-map-script',
    googleMapsApiKey: import.meta.env.VITE_GOOGLE_MAPS_API_KEY || '',
    libraries: GOOGLE_MAPS_LIBRARIES,
    language: 'en',
    region: 'US'
});

// Default center (Midland, TX - Oilfield Hub)
export const DEFAULT_MAP_CENTER = {
    lat: 31.9973,
    lng: -102.0779
};

// Map container style
export const DEFAULT_CONTAINER_STYLE = {
    width: '100%',
    height: '100%'
};

// Night mode styles for navigation
export const NIGHT_MODE_STYLES = [
    { elementType: "geometry", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.stroke", stylers: [{ color: "#242f3e" }] },
    { elementType: "labels.text.fill", stylers: [{ color: "#746855" }] },
    { featureType: "road", elementType: "geometry", stylers: [{ color: "#38414e" }] },
    { featureType: "road", elementType: "geometry.stroke", stylers: [{ color: "#212a37" }] },
    { featureType: "water", elementType: "geometry", stylers: [{ color: "#17263c" }] },
];

// Clean map style (hide POIs)
export const CLEAN_MAP_STYLES = [
    { featureType: "poi", elementType: "labels", stylers: [{ visibility: "off" }] }
];
